'use client'

import styles from './UiNotice.module.css'

/*
 * 「注意事項」那一塊 —— 舊站 dg-app.css 的 .dg-notice:
 *
 *   <div class="dg-notice">
 *     <div class="dg-notice-title">注意事項</div>
 *     <ol><li>…</li></ol>
 *   </div>
 *
 * 儲值、提領、客服、註冊、身分驗證、匯款資訊都有一塊，文字各頁不同、長相一樣。
 *
 * ⚠ 舊站的 class 名是 .dg-notice，跟儲值頁的全頁遮罩曾經撞名過（2026-09-16 踩過，
 *   見 footer2.blade.php 的註解）。CSS Modules 把 class 雜湊掉，這種撞名不會再發生。
 */
export default function UiNotice({ title = '注意事項', items = [], children }) {
  return (
    <div className={styles.notice}>
      <div className={styles.title}>{title}</div>
      {items.length ? (
        <ol className={styles.list}>
          {items.map((text, i) => (
            <li key={i}>{text}</li>
          ))}
        </ol>
      ) : null}
      {children}
    </div>
  )
}
